import { cn } from '@workspace/ui/lib/utils'
import { Lock } from 'lucide-react'

/** Marks a founder-private page: SeedForge's judgment never reaches investors. */
export function OnlyYouNote({ className }: { className?: string }) {
  return (
    <p className={cn('mb-4 flex items-center gap-1.5 text-xs text-muted-foreground', className)}>
      <Lock className="size-3" />
      Only you see this.
    </p>
  )
}
